import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getApmcOneTimeFormApplicationDocs, getDocument, getDocumentApmc } from "../../../auth/services/privateapicalling";

const SingleView: React.FC<{ docId: string | null}> = ({ docId }) => {
  const [file, setFile] = useState<{ fileData: string; mimeType: string; fileName: string } | null>(null);
  const [loading, setLoading] = useState(false);
  const token = useSelector((state: any) => state.auth.token);
const language = useSelector((state:any)=>state.auth.language);
 
  useEffect(() => {
  const loadFile = async () => {
   
    if (!docId) return;
       setFile(null)
    setLoading(true);
    try {
      
      const response = await getApmcOneTimeFormApplicationDocs( token, docId);
   

      if (response.success && response.attachments) {
        // Assuming you're interested in the first attachment
        const [key] = Object.keys(response.attachments);
        const attachment = response.attachments[key];
         setFile({
          fileData: attachment.base64,
          mimeType: attachment.contentType,
          fileName: key, // use the attachment key as filename if needed
        });
      } else {
        setFile(null);
      }
    } catch (error) {
      
      setFile(null);
    }
    setLoading(false);
  };

  loadFile();
}, [docId]);


  return (
    <div className="modal fade" id="apmc_modal" tabIndex={-1} aria-hidden="true">
      <div className="modal-dialog modal-xl modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{language.vdoc}</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body" style={{ maxHeight: "80vh", overflowY: "auto" }}>
            {loading && <p>Loading...</p>}
            {!loading && !file && <p>No document found</p>}
            {file && (
              <div className="mt-3">
             
                {file.mimeType.startsWith("image/") && (
                  <img src={file.fileData} alt={file.fileName} style={{ width: "100%", maxHeight: "70vh" }} />
                )}
                {file.mimeType === "application/pdf" && (
    <div className="border rounded overflow-hidden" style={{ height: "70vh" }}>
        <iframe
            src={(() => {
                // Convert base64 to blob URL
                const base64Data = file.fileData.split(',')[1] || file.fileData;
                const byteCharacters = atob(base64Data);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: 'application/pdf' });
                return URL.createObjectURL(blob);
            })()}
            width="100%"
            height="100%"
            title="PDF Viewer"
            className="border-0"
        />
    </div>
)}
                {!file.mimeType.startsWith("image/") && file.mimeType !== "application/pdf" && (
                  <a href={file.fileData} download={file.fileName} className="text-primary">
                    {language.down} {file.fileName}
                  </a>
                )}
              </div>
            )}
          </div>
          <div className="modal-footer d-flex justify-content-between">
            {file && (
              <a href={file.fileData} download={file.fileName} className="btn btn-success">
                {language.down}
              </a>
            )}
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
              {language.close}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleView;
